import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_METRICS_REQUEST,
  GET_AZURE_METRICS_REQUEST_SUCCESS,
  GET_AZURE_METRICS_REQUEST_ERROR,
} from "./constant";

import { getAzureMetricsRequestApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureMetricsRequestList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMetricsRequestApi, params, provider);
    yield put({ type: GET_AZURE_METRICS_REQUEST_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_METRICS_REQUEST_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureMetricsRequestSaga() {
  yield takeLatest(GET_AZURE_METRICS_REQUEST, getAzureMetricsRequestList);
}
